export default () => ({
  entries: [],
  entry: null,
  defaultEntry: {
    name: null,
    value: null
  }
})



// WEBPACK FOOTER //
// ./src/store/modules/admin/logging/state.js